import { createFileRoute } from '@tanstack/react-router'

import { FoAttestationsPage } from '../../../../../../components/pages/contract/fo-attestations-page.tsx'
import { PermissionChecker } from '../../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/(customer)/_portal/contracts/$subscriptionId/attestations')({
  component: () => (
    <PermissionChecker requiredPermissions={['contract.read']}>
      <FoAttestationsPage />
    </PermissionChecker>
  ),
})
